<template>
<div>
   <div class="container">
      <article class="message is-info">
        <div class="message-header large">
          <p>Update 26/08/2019 11:20PM</p>
          <!-- <button class="delete" aria-label="delete"></button> -->
        </div>
        <div class="message-body medium">
          <ul>
            <li>Added sort option</li>
            <li>Historical Data only (2015 - 2018) - No current Season Data</li>
          </ul>
        </div>
      </article>
    </div>
  <div class="is-parent is-12 is-vertical">
      <article class="is-child box">
      <h1 class="title">Filters</h1>
      <div class="columns">
        <div class="column is-2">
          
            <p class="subtitle has-text-primary">Teams</p>
            <div class="control">
            <div class="select is-small">
              <select v-model="selectedTeam">
                <option v-for="option in teamOptions" v-bind:value="option.value" v-bind:key="option.value">
                  {{option.text}}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="column is-2" >
          <div class="control">
            <p class=" subtitle has-text-bold">Season</p>
            <div class="select is-small">
              <select v-model="selectedSeason">
                <option v-for="option in seasonOptions" v-bind:value="option.value" v-bind:key="option.value">
                  {{option.text}}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="column is-2">
          <div class="control">
            <p class="subtitle has-text-primary">Position</p>
            <div class="select is-small">
              <select v-model="selectedPosition">
                <option v-for="option in positionOptions" v-bind:value="option.value" v-bind:key="option.value">
                  {{option.text}}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="column">
          <div class="control">
            <p class="subtitle has-text-primary">Sort By</p>
            <div class="select is-small">
              <select class="" v-model="sortSelected" @change="getSortedData()">
                <option v-for="option in sortOptions" v-bind:value="option.value" v-bind:key="option.value">
                  {{option.text}}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="column">
          <div class="control">
            <p class="subtitle has-text-primary">Find By Player</p>
            <input class="input" style="height:3em;" type="text" placeholder="Search" v-model="search">
          </div>
        </div>
      </div>
    </article>
  </div>
  <div class=" is-parent is-vertical">
    <article class="is-child box">
    <table class="table is-striped is-responsive">
      <thead>
        <th>Team</th>
        <th>Season</th>
        <th>Nationality</th>
        <th title="Position">P</th>
        <th title="Player Number">#</th>
        <th>Name</th>
        <th title="Games Played">GP</th>
        <th title="Total Goals">G</th>
        <th title="Total Assists">A</th>
        <th title="Total Points">Pts</th>
        <th title="Goals Per Game">GPG</th>
        <th title="Assists Per Game">APG</th>
        <th title="Points Per Game">PPG</th>
        <th title="Individual Goal Percentage">IGP</th>
        <th title="Individual Assists Percentage">IAP</th>
        <th title="Individual Points Percentage">IPP</th>
      </thead>
      <tbody>
        <tr v-for="player in computed_data" v-bind:key="player.id">
          <td>{{player.team}}</td>
          <td>{{player.season}}</td>
          <td>{{player.nationality}}</td>
          <td>{{player.position}}</td>
          <td>{{player.number}}</td>
          <td>{{player.name}}</td>
          <td>{{player.gp}}</td>
          <td>{{player.g}}</td>
          <td>{{player.a}}</td>
          <td>{{player.tp}}</td>
          <td>{{player.gpg | formatDecimal}}</td>
          <td>{{player.apg | formatDecimal}}</td>
          <td>{{player.ppg | formatDecimal}}</td>
          <td>{{player.igp}}%</td>
          <td>{{player.iap}}%</td>
          <td>{{player.ipp}}%</td>
        </tr>
      </tbody>
    </table>
    </article>
  </div>
</div>
</template>
<script>
import _ from 'lodash'
export default {
  name: 'PlayerEquiv',
  data () {
    return {
      players: [],
      selectedTeam: -1,
      selectedSeason: -1,
      selectedPosition: -1,
      search: '',
      sortSelected: 'g',
      sortOptions: [],
      teamOptions: [
        {
          text: 'All',
          value: -1
        },
        {
          text: 'Manchester Storm',
          value: 'MAN'
        },
        {
          text: 'Cardiff Devils',
          value: 'CAR'
        },
        {
          text: 'Sheffield Steelers',
          value: 'SHE'
        },
        {
          text: 'Belfast Giants',
          value: 'BEL'
        },
        {
          text: 'Coventry Blaze',
          value: 'COV'
        },
        {
          text: 'Guildford Flames',
          value: 'GUI'
        },
        {
          text: 'Milton Keynes Lightning',
          value: 'MKL'
        },
        {
          text: 'Nottingham Panthers',
          value: 'NOT'
        },
        {
          text: 'Dundee Stars',
          value: 'DUN'
        },
        {
          text: 'Braehead / Glasgow Clan',
          value: 'BRA'
        },
        {
          text: 'Fife Flyers',
          value: 'FIF'
        }
      ],
      seasonOptions: [
        {
          text: 'All',
          value: -1
        },
        {
          text: '15-16',
          value: '15-16'
        },
        {
          text: '16-17',
          value: '16-17'
        },
        {
          text: '17-18',
          value: '17-18'
        },
        {
          text: '18-19',
          value: '18-19'
        }
      ],
      positionOptions: [
        {
          text: 'All',
          value: -1
        },
        {
          text: 'Forwards',
          value: 'F'
        },
        {
          text: 'Defense',
          value: 'D'
        }
      ]
    }
  },
  computed: {
    computed_data: function () {
      let filterTeam = this.selectedTeam
      let filterSeason = this.selectedSeason
      let filterPosition = this.selectedPosition
      let filterSearch = this.search
      return _.orderBy(this.players.filter(function (itm) {
        let filtered = true
        if (filterSearch !== '') {
          // console.log('Searching' + filterSearch)
          let lowerName = itm.name.toLowerCase()
          filtered = lowerName.includes(filterSearch.toLowerCase())
        } else if (filterSeason && filterSeason !== -1) {
          filtered = itm.season === filterSeason
        } else if (filterTeam && filterTeam !== -1) {
          filtered = itm.team === filterTeam
        } else if (filterPosition && filterPosition !== -1) {
          filtered = itm.position === filterPosition
        } else {
          return true
        }
        if (filterPosition && filterPosition !== -1 && filterSeason && filterSeason !== -1) {
          filtered = itm.season === filterSeason && itm.position === filterPosition
        }
        if (filterTeam && filterTeam !== -1 && filterSeason && filterSeason !== -1) {
          filtered = itm.team === filterTeam && itm.season === filterSeason
        }
        if (filterTeam && filterTeam !== -1 && filterPosition && filterPosition !== -1) {
          filtered = itm.team === filterTeam && itm.position === filterPosition
        }
        if (filterTeam && filterTeam !== -1 && filterPosition && filterPosition !== -1 && filterSeason && filterSeason !== -1) {
          filtered = itm.team === filterTeam && itm.position === filterPosition && itm.season === filterSeason
        }
        return filtered
      }), this.sortSelected, ['desc'])
    }
  },
  filters: {
    formatDecimal: function (value) {
      return Number(value).toFixed(2)
    }
  },
  methods: {
    fetchPlayerEquiv () {
      this.$http.get('https://devilsapi.roblutken.com/api/app/get/player-equiv/', { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } })
        .then(
          response => {
            this.players = response.data.players
          },
          response => {}
        )
    }
  },
  created: function () {
    this.fetchPlayerEquiv()
    this.sortOptions.push({text: 'Team', value: 'team'})
    this.sortOptions.push({text: 'Season', value: 'season'})
    this.sortOptions.push({text: 'Nationality', value: 'nationality'})
    this.sortOptions.push({text: 'Position', value: 'position'})
    this.sortOptions.push({text: 'Name', value: 'name'})
    this.sortOptions.push({text: 'GP', value: 'gp'})
    this.sortOptions.push({text: 'Goals', value: 'g'})
    this.sortOptions.push({text: 'Assists', value: 'a'})
    this.sortOptions.push({text: 'Total Points', value: 'tp'})
    this.sortOptions.push({text: 'Goals Per Game', value: 'gpg'})
    this.sortOptions.push({text: 'Assists Per Game', value: 'apg'})
    this.sortOptions.push({text: 'Points Per Game', value: 'ppg'})
    this.sortOptions.push({text: 'Individual Goals %', value: 'igp'})
    this.sortOptions.push({text: 'Individual Assists %', value: 'iap'})
    this.sortOptions.push({text: 'Individual Points %', value: 'ipp'})
  }
}
</script>



// WEBPACK FOOTER //
// player-equivalency.vue?27fbfbc6